import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input('totalItem') totalItem: number;
  @Input('itemPerPage') itemPerPage: number;
  @Input('currentPage') currentPage: number;
  @Input('isIpadMobile') isIpadMobile: boolean = false;
  @Input() detailless = false;

  @Output('onGoToPage') onGoToPage = new EventEmitter();

  public totalPage: number;
  public centerPaginations: any;

  constructor(
    private utilitiesService: UtilitiesService
  ) {}

  ngOnInit() {
    this.initialPagination();
  }

  ngOnChanges() {
    this.initialPagination();
  }

  initialPagination() {
    this.totalPage = Math.ceil(this.totalItem / this.itemPerPage);
    this.getCenterPaginations();
  }

  isDiabledPrevBtn(){
    return this.currentPage == 1;
  }
  isDiabledNextBtn(){
    return this.currentPage == this.totalPage;
  }

  isShowFirstDot() {
     return this.currentPage > 4;
  }

  isShowFirstNumberDot(){
    return this.currentPage < 5;
  }
  isShowLastNumberDot(){
    return this.currentPage > this.totalPage - 4;
  }

  isShowLastDot() {
    return this.currentPage < this.totalPage - 3;
  }

  nextPage(){
    let nextIndex = this.currentPage < this.totalPage? this.currentPage+1: this.totalPage;
    this.setCurrentPage(nextIndex);
  }

  prevPage(){
    let prevIndex = this.currentPage > this.totalPage? this.totalPage: this.currentPage-1;
    this.setCurrentPage(prevIndex);
  }

  setCurrentPage(index) {
    this.currentPage = index;
    this.getCenterPaginations();
    this.onGoToPage.emit({ data: index });

  }

  getLastPage() {
    return Math.round(this.totalPage);
  }

  getCenterPaginations() {
    let _centerPaginations = [];
    let _currentPage = this.currentPage;
    let _totalPage = this.getLastPage();

    // detect min and max range number
    if ( _currentPage < 5 ) {
      _currentPage = 5
    } else if ( _currentPage > _totalPage - 5 ) {
      _currentPage = _totalPage - 4
    }

    for(let i=0; i<5; i++) {
      let index = _currentPage + (i-2);
      if ( index > 0 && index < _totalPage ) {
        _centerPaginations.push(index);
      }
    }
    this.centerPaginations = _centerPaginations;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/pagination/pagination.component.ts